import { StorageProvider } from "../../../contexts/storage/storage-provider";
import { ProgramScheduleTable } from "../shared/ProgramScheduleTable";
import { RiverDischargesTable } from "../shared/RiverDischargesTable";

const Container: React.FC = () => {
  return (
    <ProgramScheduleTable title="Descargas">
      <RiverDischargesTable />
    </ProgramScheduleTable>
  );
};

const RiverDischarges: React.FC = () => {
  return (
    <StorageProvider>
      <Container />
    </StorageProvider>
  );
};

export default RiverDischarges;
